module.exports = __webpack_public_path__ + "static/img/icon_36.32a8074.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_36.png
// module id = r/o7
// module chunks = 1